<template>
    <div class="card" data-testid="reception-tasks">
        <div class="card-header">
            <div class="row">
                <div class="col-md-3">
                    <b>Úkoly</b>
                </div>
                <div class="col-md-9">
                    <button class="btn btn-sm btn-success" v-if="getParams.f.state === 'scheduled'" data-testid="reception-tasks-filter-scheduled">nevyřízeno</button>
                    <button class="btn btn-sm btn-outline-secondary" v-else="" @click="selectScheduledState()" data-testid="reception-tasks-filter-scheduled">nevyřízeno</button>

                    <button class="btn btn-sm btn-success" v-if="getParams.f.state === 'completed'" data-testid="reception-tasks-filter-completed">splněno</button>
                    <button class="btn btn-sm btn-outline-secondary" v-else="" @click="selectCompletedState()" data-testid="reception-tasks-filter-completed">splněno</button>

                    <button class="btn btn-sm btn-success" v-if="getParams.f.state === 'canceled'">zrušeno</button>
                    <button class="btn btn-sm btn-outline-secondary" v-else="" @click="selectCanceledState()">zrušeno</button>
                </div>
            </div>
        </div>
        <div class="card-header">
            <div class="row">
                <div class="col-md-10 text-center">
                    <select v-model="plannedFor" class="mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat doktora" v-if="doctors.length > 0" data-testid="reception-tasks-doctor">
                        <option :value="null">všichni doktoři</option>
                        <option v-for="row in doctors" v-bind:value="row.id">{{ row.fullname }}</option>
                    </select>
                </div>
                <div class="col-md-2 text-right">
                    <button @click="getDoctorsDayVisits()" class="btn btn-secondary btn-sm"><i class="fa fa-refresh"></i></button>
                </div>
            </div>
        </div>
        <div class="card-body pl-0 pr-0" v-if="listData.length > 0">
            <template v-for="(visit, index) in listData">
                <div class="row ml-0 mr-0 card_row" :data-testid="'reception-task-' + visit.id">
                    <div class="col-sm-auto pl-2 pr-0 pt-2">
                        <i class="fa fa-2x fa-exclamation text-danger text_blink" :class="visit.acute === true ? '':'invisible'" aria-hidden="true"></i>
                    </div>
                    <div class="col-sm-auto pl-0 pr-0">
                        <visit-task-change-state v-on:update="getDoctorsDayVisits" :actual-state="visit.state" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id"></visit-task-change-state>
                    </div>
                    <div class="col pl-0 pr-0">
                        <div class="row m-0">
                            <div class="col-md-6">
                                <router-link class="text-secondary" :to="{ name: 'ShowClient', params: { clientid: visit.client.id }}"><i class="fa fa-address-card-o" aria-hidden="true"></i></router-link> <b>{{ visit.client.first_name }} {{ visit.client.last_name }}</b>
                            </div>
                            <div class="col-md-6">
                                <span v-tooltip="{
                                    content: 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b>',
                                    placement: 'bottom-center',
                                    classes: ['info']}">
                                    {{ visit.planned_at }}
                                </span>
                            </div>
                        </div>
                        <div class="row m-0">
                            <div class="col-md-12">
                                <template>
                                    <button @click="showHideVisitDetail(index)" class="btn btn-sm btn_extra_small btn-primary" :data-testid="'reception-task-detail-' + visit.id"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
                                </template>
                                <router-link :to="{ name: 'ShowVisit', params: { clientid: visit.client.id, visitid: visit.id }}">
                                    <b>{{ visit.visit_purpose.purpose }}</b>
                                </router-link>
                                <template v-if="editingVisitId === visit.id ">
                                    <form class="form-inline" @submit.prevent="putVisit(visit)">
                                        <label for="note">poznámka: </label>
                                        <input v-model="editingVisit.note" type="text" class="form-control ml-sm-1 col-sm-10 mr-sm-2" aria-describedby="noteHelp" id="note" :data-testid="'reception-task-note-' + visit.id">
                                        <label class="mr-sm-2" for="doctor">K doktorovi</label>
                                        <select v-model="editingVisit.planned_for" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat doktora" autofocus="autofocus">
                                            <option v-for="row in doctors" v-bind:value="row.id">{{ row.fullname }}</option>
                                        </select>
                                        <label for="acute" class="mr-sm-2">
                                            prioritní <input v-model="editingVisit.acute" class="form-check-input" type="checkbox" id="acute">
                                        </label>
                                        <button v-if="!waitForSave" type="submit" class="btn btn-primary" :data-testid="'reception-task-save-' + visit.id">Uložit</button>
                                        <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                    </form>
                                </template>
                                <template v-else=""><button @click="editVisit(visit, visit.id)" class="btn btn-sm btn-link text-secondary" :data-testid="'reception-task-edit-' + visit.id"><i class="fa fa-pencil" aria-hidden="true"></i></button><i>poznámka: {{ visit.note }}</i></template>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-auto pl-0 pr-0">
                        <button type="button"
                                class="btn btn-primary btn_circle btn_md vertically_centered"
                                v-tooltip="{
                                    content: 'naplánováno pro: <b>' + visit.planned_for.fullname + '</b> <br>' + 'vytvořil/a: <b>' + visit.planned_by.fullname + '</b><br>dne <b>' + visit.planned_at + '</b>',
                                    placement: 'bottom-center',
                                    classes: ['info']}">
                            {{ visit.planned_for.monogram.toUpperCase() }}
                        </button>
                    </div>
                    <div class="col-sm-auto">
                        <span class="fa fa-2x fa-angle-right text-primary vertically_centered invisible" aria-hidden="true"></span>
                    </div>
                </div>
                <div v-if="showedVisitDetail.indexOf(index) > -1" class="card_row">
                    <div class="p-2">
                        <div class="row m-0" v-if="visit.presenting_complaint">
                            <h6>{{ visit.presenting_complaint.anamnesis_type.name }}</h6>
                            <div v-html="visit.presenting_complaint.text"></div>
                        </div>
                        <div class="row m-0" v-else-if="visit.medical_report">
                            <h6>Lékařská zpráva</h6>
                            <div v-html="visit.medical_report.text"></div>
                        </div>
                        <div class="row m-0" v-if="visit.diagnosis.length > 0">
                                <h6>Diagnózy a výkony</h6>
                                <div>
                                    <table class="table">
                                        <tbody>
                                        <template v-for="diagnose in visit.diagnosis">
                                            <tr>
                                                <td>{{ diagnose.disease.code }}</td>
                                                <td>{{ diagnose.disease.name_cs }}</td>
                                            </tr>
                                            <template v-if="diagnose.actions.length > 0">
                                                <template v-for="action in diagnose.actions">
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            {{ action.operation.code }} - {{ action.operation.name }}
                                                        </td>
                                                    </tr>
                                                    <template v-if="action.zulp.length > 0">
                                                        <tr v-for="zulp in action.zulp">
                                                            <td></td>
                                                            <td>
                                                                &nbsp;&nbsp;&nbsp;zulp: {{ zulp.amount }}x {{ zulp.medicine.label }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template v-if="action.zum.length > 0">
                                                        <tr v-for="zum in action.zum">
                                                            <td></td>
                                                            <td>
                                                                &nbsp;&nbsp;&nbsp;zum: {{ zum.amount }}x {{ zum.material.label }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else="">
                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        <i>(diagnóza nemá přidělené výkony)</i>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        <div class="row m-0" v-if="visit.medicament.length > 0">
                                <h6>Léčiva</h6>
                                <div>
                                        <table class="table">
                                            <tbody>
                                            <tr v-for="m in visit.medicament">
                                                <td>{{ m.medicine ? m.medicine.label : '' }}
                                                  {{ m.individual_medicine ? m.individual_medicine.name : '' }}</td>
                                                <td>{{ m.dosage }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                </div>
                        </div>
                    </div>
                </div>
            </template>
            <pagination-component :list-pagination="listPagination" @set-page="setPage"/>
        </div>
        <div class="card-body" v-else-if="listPending">
            <div class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                    (načítám)
            </div>
        </div>
        <div class="card-body" v-else="">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (na tento den není nic naplánováno)
            </div>
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'

  import moment from 'moment'
  import VisitChangeDoctor from '../components/VisitChangeDoctor.vue'
  import VisitTaskChangeState from '../components/VisitTaskChangeState.vue'

  import Datepicker from 'vuejs-datepicker'
  import PaginationComponent from '../../../components/PaginationComponent.vue'

  export default {
    data () {
      return {
        showedVisitDetail: [],
        visits_header_title: '',
        setting: require('../../../variables.js'),
        selected_date: '',
        getParams: {
          p: 1,
          s: 'acute-planned_at+',
          f: {
            state: 'scheduled'
          },
          pp: 15
        },
        selectedStates: [],
        print_date: '',
        plannedFor: '',
        doctors: [],
        doctorsPending: false,
        doctorsError: false,
        selectedDoctorId: null,
        showDoctorModal: false,
        selectedDate: '',
        listData: false,
        listError: false,
        listPagination: null,
        listPending: false,
        waiting: true,
        editingVisitId: false,
        editingVisit: {},
        waitForSave: false
      }
    },
    mixins: [apiMixin],
    methods: {
      setPage (number) {
        this.getParams.p = number
        this.getDoctorsDayVisits()
      },
      showHideVisitDetail (index) {
        if (this.showedVisitDetail.indexOf(index) === -1) {
          this.showedVisitDetail.push(index)
        } else {
          this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1)
        }
      },
      editVisit (visit, id) {
        this.editingVisitId = id
        this.editingVisit = {
          note: visit.note,
          acute: visit.acute,
          planned_for: visit.planned_for.id
        }
      },
      putVisit () {
        this.waitForSave = true
        this.$http.put('visit_task/' + this.editingVisitId, this.editingVisit, {emulateJSON: true}).then(response => {
          this.waitForSave = false
          this.editingVisitId = false
          this.editingVisit = {}
          this.getDoctorsDayVisits()
        }, response => {
          this.errors = response.data.errors
          this.waitForSave = false
        })
      },
      changeState (visitId, event) {
        this.$http.put('visit_task/' + visitId + '/change_state', {state: event.target.value}, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.waitForResponse = false
          this.getDoctorsDayVisits()
        }, response => {
          this.errors = response.data.errors
          this.waitForResponse = false
        })
      },
      getDoctorsDayVisits () {
        this.getTasks(this.getParams)
      },
      selectToday () {
        this.selectedDate = moment().toDate()
      },
      selectTomorrow () {
        this.selectedDate = moment().add(1, 'days').toDate()
      },
      setDateAndLoad () {
        switch (this.selected_date.startOf('day').diff(moment().startOf('day'), 'days')) {
          case 0:
            this.print_date = 'Dnes (' + moment(this.selected_date).format('DD.MM.YYYY') + ')'
            break
          case 1:
            this.print_date = 'Zítra (' + moment(this.selected_date).format('DD.MM.YYYY') + ')'
            break
          case -1:
            this.print_date = 'Včera (' + moment(this.selected_date).format('DD.MM.YYYY') + ')'
            break
          default:
            this.print_date = moment(this.selected_date).format('dddd') + ' (' + moment(this.selected_date).format('DD.MM.YYYY') + ')'
        }
        this.getDoctorsDayVisits()
        this.waiting = false
      },
      moment: function (date) {
        return moment(date)
      },
      showModalChangeVisitDoctor (selectedDoctorId) {
        this.selectedDoctorId = selectedDoctorId
        this.showModal('visit-change-doctor')
      },
      showModal (name) {
        console.log('zobrazuji modal')
        this.$modal.show(name)
      },
      membershipExpiresSoon (membership) {
        if (this.$moment(membership.valid_to, 'DD.MM.YYYY').diff(this.$moment(), 'days') < 31) {
          return true
        } else {
          return false
        }
      },
      selectScheduledState () {
        this.getParams.f.state = 'scheduled'
        this.getParams.s = 'acute-planned_at+'
        this.getDoctorsDayVisits()
      },
      selectCompletedState () {
        this.getParams.f.state = 'completed'
        this.getParams.s = 'completed_at-'
        this.getDoctorsDayVisits()
      },
      selectCanceledState () {
        this.getParams.f.state = 'canceled'
        this.getParams.s = 'planned_at-'
        this.getDoctorsDayVisits()
      }
    },
    beforeMount () {
      this.getDoctors()
      moment.locale('cs')
      if (this.$ls.get('home_date')) {
        this.waiting = true
        // this.plannedFor = this.$ls.get('userid')
        this.selectedDate = moment(this.$ls.get('home_date'), 'DD.MM.YYYY').toDate()
      } else {
        this.selectToday()
        this.$ls.set('home_date', moment().format('DD.MM.YYYY'))
      }
    },
    watch: {
      plannedFor: function (val) {
        if (val === null) {
          delete this.getParams.f.planned_for
        } else {
          this.getParams.f.planned_for = val
        }

        this.getDoctorsDayVisits()
      },
      selectedDate: function (val) {
        this.$ls.set('home_date', moment(val).format('DD.MM.YYYY'))
        this.selected_date = moment(val)
        this.setDateAndLoad()
      }
    },
    components: {
      PaginationComponent,
      VisitChangeDoctor,
      VisitTaskChangeState,
      Datepicker
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

</style>



// WEBPACK FOOTER //
// src/views/HomeReceptionist/components/Tasks.vue?948e57f0